import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  font-family: 'Poppins', sans-serif;
  padding: 60px 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const Card = styled.div`
  flex: 1 1 30%;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 12px;
  padding: 30px;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 250px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }

  @media (max-width: 992px) {
    flex: 1 1 45%;
  }

  @media (max-width: 600px) {
    flex: 1 1 100%;
  }
`;

const Icon = styled.div`
  margin-bottom: 20px;
  img {
    width: 60px;
    height: 60px;
  }
`;

const Title = styled.h4`
  font-size: 22px;
  margin-bottom: 10px;
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
`;

const Vision = ({ landingPrimaryColor }) => {
  return (
    <Section>
      <Container>
        <Row>
          <Card bgColor={landingPrimaryColor}>
            <Icon>
              <img src="img/misc/vision.png" alt="Vision" />
            </Icon>
            <Title>Vision</Title>
            <Description>
              To be the trusted leader in providing seamless recharge and utility bill payment services
            </Description>
          </Card>

          <Card bgColor={landingPrimaryColor}>
            <Icon>
              <img src="img/misc/mission.png" alt="Mission" />
            </Icon>
            <Title>Mission</Title>
            <Description>
              To offer fast, secure, and cost-effective recharge solutions that simplify the process for businesses and customers
            </Description>
          </Card>

          <Card bgColor={landingPrimaryColor}>
            <Icon>
              <img src="img/misc/service.png" alt="Service" />
            </Icon>
            <Title>Service</Title>
            <Description>
              We provide services with a 99% success rate, ensuring fast, reliable, and complaint-free experiences
            </Description>
          </Card>
        </Row>
      </Container>
    </Section>
  );
};

export default Vision;
